import '../styles/index.scss'

import './core/voice'
import './core/rellax'
import './core/quantity'
import './core/lazy-load'
import './core/smooth-scroll'
import './core/scroll-anchor'
import './core/textareas'
import './core/popups'

import './components'
import { Progress } from './core/progress'

export const progress = new Progress(document.body, 'progress-general')

const forms = document.querySelectorAll('.sea-form')
if (forms.length > 0) {
  import(/* webpackChunkName: "sea-forms" */ './sea-forms').then(
    ({ SeaForm }) => {
      forms.forEach((form) => new SeaForm(form))
    }
  )
}
